import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  addFile,
  addValue,
  copyValue,
  getForms,
  getHistory,
  loadFrom,
  incrimentToSend,
  markAllVisited,
  markVisited,
  checkedPanel,
  recal,
  setError,
  setSection,
} from '../actions';

import RequestWithoutStore from '../modules/metajson-sub';
import Actions from './controls/Actions';

import { createApiClient } from '../services/ApiClient';
import { ActionsDefaultState, ActionsRules } from '../const/action_rules';
import * as FieldsRules from '../const/field_rules';
import * as FormRules from '../const/forms';
import { createGridCandidateRequestExpertField } from './controls/GridCandidateRequestExpertField';
import { createAutocompleteTextboxField } from './controls/AutocompleteTextboxField';

class RequestForm extends Component {
  componentDidMount() {
    const {
      params: { form_type, process_id },
    } = this.props;
    this.api = createApiClient(form_type, process_id);
  }

  render() {
    return (
      <RequestWithoutStore
        api={this.api}
        extRules={{
          ActionsDefaultState,
          ActionsRules,
          ...FieldsRules,
          ...FormRules,
        }}
        extActions={Actions}
        {...this.props}
        //Дополнительные контролы специфичные для проекта
        remoteControls={{
          GridCandidateRequestExpertField: createGridCandidateRequestExpertField,
          AutocompleteTextboxField: createAutocompleteTextboxField,
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  schema: state.forms,
  loaders: state.forms.loaders,
  sections: state.forms.form.sections,
});

const mapDispatchToProps = dispatch => ({
  setSection: id => dispatch(setSection(id)),
  addValue: (id, value, refresh, action) =>
    dispatch(addValue(id, value, refresh, action)),
  addFile: (id, filename) => dispatch(addFile(id, filename)),
  checkedPanel: (panelId, checked, error) =>
    dispatch(checkedPanel(panelId, checked, error)),
  incrimentToSend: () => dispatch(incrimentToSend()),
  loadFrom: (form_type, process_id) =>
    dispatch(loadFrom(form_type, process_id)),
  copyValue: (sourceId, targetId) => dispatch(copyValue(sourceId, targetId)),
  recal: () => dispatch(recal()),
  markVisited: id => dispatch(markVisited(id)),
  setError: (id, error) => dispatch(setError(id, error)),
  markAllVisited: () => dispatch(markAllVisited()),
  getForms: (page, pagesize) => dispatch(getForms(page, pagesize)),
  getHistory: id => dispatch(getHistory(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestForm);
